"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiRadio = void 0;
var styles_1 = require("@material-ui/core/styles");
var palette_1 = require("../../../theme/global/palette");
exports.MuiRadio = {
    root: {
        color: palette_1.palette.grey[500],
        padding: 6,
        marginRight: 4,
        '&.Mui-focusVisible': {
            backgroundColor: (0, styles_1.alpha)(palette_1.palette.primary.light, 0.1),
        },
    },
    colorPrimary: {
        '&$checked': {
            color: palette_1.palette.primary.light,
            '&:hover': {
                backgroundColor: (0, styles_1.alpha)(palette_1.palette.grey[500], 0.1),
            },
        },
        '&:hover': {
            backgroundColor: (0, styles_1.alpha)(palette_1.palette.grey[500], 0.1),
        },
        '&:active': {
            backgroundColor: (0, styles_1.alpha)(palette_1.palette.primary.light, 0.1),
        },
    },
};
